const dev = 'https://numerizedevapi.aautipay.com/'
const prod = ''
const local = 'http://10.30.3.103:3000/'
export const baseUrl = dev
